import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar } from '../../components';
import { DateTime } from 'luxon';
import { getStartOfDay, getEndOfDay, formatToIsoDate } from '../../utils/date';
import { useEffect, useState } from 'react';
import usePrevious from '../../hooks/usePrevious';
const CalendarFilter = ({ setDateRange, limitRangeSelection, presetDates, disableBefore, disableToday, disableFuture, ianaTimeZoneCode, }) => {
    const todayInIsoDate = formatToIsoDate(new Date(), ianaTimeZoneCode);
    const yesterdayInIsoDate = DateTime.fromISO(todayInIsoDate)
        .minus({ day: 1 })
        .toISODate();
    const [fromDate, setFromDate] = useState(presetDates
        ? formatToIsoDate(presetDates.fromDate, ianaTimeZoneCode)
        : yesterdayInIsoDate);
    const [toDate, setToDate] = useState(presetDates
        ? formatToIsoDate(presetDates.toDate, ianaTimeZoneCode)
        : todayInIsoDate);
    const prevPresetDates = usePrevious(presetDates);
    useEffect(() => {
        if (presetDates &&
            (prevPresetDates === null || prevPresetDates === void 0 ? void 0 : prevPresetDates.fromDate) !== presetDates.fromDate &&
            (prevPresetDates === null || prevPresetDates === void 0 ? void 0 : prevPresetDates.toDate) !== presetDates.toDate &&
            (prevPresetDates === null || prevPresetDates === void 0 ? void 0 : prevPresetDates.title) !== presetDates.title) {
            setFromDate(formatToIsoDate(presetDates.fromDate, ianaTimeZoneCode));
            setToDate(formatToIsoDate(presetDates.toDate, ianaTimeZoneCode));
        }
    }, [presetDates, prevPresetDates, ianaTimeZoneCode]);
    return (_jsx(Calendar, { from: fromDate || undefined, to: toDate || undefined, limitRangeSelection: limitRangeSelection, onChange: ({ from, to }) => {
            // Calendar returns dates as 'yyyy-MM-dd' strings
            // Added default time range, Removed existing timezone consverion
            const fromDate = from
                ? DateTime.fromISO(getStartOfDay(from)).toJSDate()
                : null;
            const toDate = to ? DateTime.fromISO(getEndOfDay(to)).toJSDate() : null;
            setFromDate(from || null);
            setToDate(to || null);
            setDateRange(fromDate, toDate);
        }, disableBefore: disableBefore, disableToday: disableToday, disableFuture: disableFuture, ianaTimeZoneCode: ianaTimeZoneCode }, void 0));
};
export default CalendarFilter;
